<template>
  <div class="home">
    <div class="text-center mt-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">{{ $t('common.loading') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

export default {
  name: 'HomePage',
  setup() {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    
    onMounted(() => {
      // Redirect to appropriate page based on auth status
      const isAuthenticated = store.getters['auth/isAuthenticated'];
      
      if (isAuthenticated) {
        const currentUser = store.getters['auth/currentUser'];
        const hasBuyerTenantAccess = currentUser?.editionId?.toUpperCase() === '98CAF202-9D8E-B62F-01C1-39FF3E9F71A0';
        
        if (hasBuyerTenantAccess) {
          router.replace('/lookup');
        } else {
          router.replace('/profile');
        }
      } else {
        router.replace('/login');
      }
    });
    
    return { t };
  }
};
</script> 